import type { Mouvement } from '@mairistem/comptabilite';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import type BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauModifierAction from '../actions/BordereauModifierAction';
import BaseBordereauState from './BaseBordereauState';

class BordereauNouveauState extends BaseBordereauState {
	constructor() {
		super();
		this.step = BordereauStateStep.NOUVEAU;
		this.state = BordereauStateType.NOUVEAU;
		this.color = '#9747FF';
		this.libelle = 'Nouveau';
	}

	getBordereauActions(): BaseLiquidationAction<
		BordereauWithState,
		BordereauActionType
	>[] {
		return [
			new BordereauModifierAction({
				isActionPrincipale: true,
				isCreation: true,
			}),
		];
	}

	getMouvementActions(): BaseLiquidationAction<
		Mouvement,
		MouvementActionType
	>[] {
		return [];
	}
}

export default BordereauNouveauState;
